import React from 'react';
import { Box, Slider, Typography } from '@mui/material';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import { useFontSize } from '../theme/FontSizeContext';

const FontSizeSlider = () => {
    const { fontSize, changeFontSize, config } = useFontSize();

    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2,
            mb: 2,
            px: 2 
        }}>
            <FormatSizeIcon />
            <Slider
                value={fontSize}
                min={config.min}
                max={config.max}
                step={1}
                onChange={(_, value) => changeFontSize(value)}
                valueLabelDisplay="auto"
                valueLabelFormat={value => `${value}`}
                sx={{ 
                    minWidth: 100,
                    width: '100%',
                    maxWidth: 200 
                }}
                aria-label="字体大小"
            />
            <Typography variant="body2" sx={{ minWidth: 40 }}>
                字号{fontSize}
            </Typography>
        </Box>
    );
};

export default FontSizeSlider; 